const setImpersonationToLS = (impersonate, impersonateId, impersonateName) => {
  sessionStorage.setItem('impersonate', impersonate);
  sessionStorage.setItem('impersonateId', impersonateId);
  sessionStorage.setItem('impersonateName', impersonateName);
};

export default setImpersonationToLS;
